import { Box, Flex, HStack, Text, useSlotRecipe } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { MessageBoxProps } from './message-box.props';

export const MessageBox = ({
    title,
    message,
    variant = 'info',
    size = 'lg',
    ...props
}: MessageBoxProps) => {
    const recipe = useSlotRecipe({ key: 'messageBox' });
    const styles = recipe({ variant, size });

    return (
        <HStack align={'stretch'} gap={4} css={styles.root} {...props}>
            <Flex css={styles.iconContainer}>
                <IconsLinear.InfoCircle
                    color={'white'}
                    size={size}
                    rotate={variant === 'info' ? '180deg' : undefined}
                />
            </Flex>
            <Box css={styles.content}>
                {title ? <Box css={styles.title}>{title}</Box> : null}
                {message ? <Text css={styles.message}>{message}</Text> : null}
            </Box>
        </HStack>
    );
};
